import { CellItemHeight } from '../constants';

export const getAmountCellStyles = () => ({
  '@global': {
    '& .ChangeAmount.ms-DetailsRow-cell': {
      padding: 0,
    },
  },
  AmountCell: {
    width: '100%',
  },
  AmountItem: {
    width: '100%',
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 12,
    paddingRight: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  BorderBottomLine: {
    borderBottom: '1px solid rgb(243, 242, 241)',
  },
  Description: {
    color: '#605E5C',
    fontSize: 11,
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  [`AmountItem-${CellItemHeight.Large}`]: {
    height: 62,
  },
  [`AmountItem-${CellItemHeight.Small}`]: {
    height: 44,
  },
  GreenColor: {
    color: '#107C10',
  },
});
